const t=(t,e)=>t.depth-e.depth;export{t as compareByDepth};
